import React from "react";

function ICODevService() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                ICO Development Service by Xeer Technology
              </h2>
              <h3>
                Drive Your Vision to Success with Xeer Technology’s ICO Services
              </h3>
              <p>
                Launching an Initial Coin Offering (ICO) can be transformative,
                enabling startups and established ventures alike to raise
                substantial capital and expand their projects. At Xeer
                Technology, we specialize in end-to-end ICO services designed to
                make your token sale secure, compliant, and effective. From
                token development to community outreach, our team of blockchain
                experts ensures a seamless ICO journey, empowering you to focus
                on growth and innovation.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ICODevService;
